module.exports = __webpack_public_path__ + "img/foot_code.28c73d90.png";